module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalCompteRenduDsnComponent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "tw-flex tw-w-full tw-items-center"
  }, [_c('div', {
    staticClass: "head d-flex tw-items-center"
  }, [_c('div', {
    staticClass: "label mr-2"
  }, [_vm._v("Nature des retours : ")]), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon mr-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.natureSelectionnee),
      expression: "natureSelectionnee"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.natureSelectionnee = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.refreshAllReturns();
        _vm.refreshAnomalies();
      }]
    }
  }, _vm._l((_vm.optionsNatureRetour), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                    " + _vm._s(option.label) + "\n                                ")])
  })), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-items-center tw-gap-[15px]"
  }, [(_vm.ligneCompteRenduSelectionne && _vm.anomaliesList) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAnomalieType),
      expression: "selectedAnomalieType"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAnomalieType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Toutes les anomalies")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueAutres
    }
  }, [_vm._v(" Autre")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueSalarie
    }
  }, [_vm._v(" Salarié")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueIdentifiant
    }
  }, [_vm._v(" Identifiant")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedAnomalieType === _vm.valueSalarie) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSalarie),
      expression: "selectedSalarie"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSalarie = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Tout les salariés")]), _vm._v(" "), _vm._l((_vm.salarieList), function(item) {
    return _c('option', [_vm._v(" " + _vm._s(item))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedAnomalieType === _vm.valueIdentifiant) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIdentifiant),
      expression: "selectedIdentifiant"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIdentifiant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Tout les identifiants")]), _vm._v(" "), _vm._l((_vm.identifiantList), function(item) {
    return _c('option', [_vm._v(" " + _vm._s(item))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "body-table"
  }, [_c('table', {
    staticClass: "generic-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.filteredList), function(item) {
    return _c('tr', [_c('th', {
      staticClass: "cln-nature"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center",
      attrs: {
        "title": item.Nature
      }
    }, [_vm._v(_vm._s(item.Nature))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-libelle"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-start tw-text-center",
      attrs: {
        "title": item.NatureLibelle
      }
    }, [_vm._v(_vm._s(item.NatureLibelle))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-statut"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center",
      attrs: {
        "title": item.Statut
      }
    }, [_vm._v(_vm._s(item.Statut))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-action"
    }, [(item.CodeDocumentGed) ? _c('button', {
      staticClass: "inp-button blue",
      attrs: {
        "type": "button",
        "title": "Télécharger"
      },
      on: {
        "click": function($event) {
          _vm.telecharger(item)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-file-download"
    }), _vm._v(" "), _c('div', {
      staticClass: "text ml-2"
    }, [_vm._v("Télécharger")])]) : _vm._e(), _vm._v(" "), (_vm.isVisibleMajTauxPas(item)) ? _c('button', {
      staticClass: "inp-button green",
      attrs: {
        "type": "button",
        "title": "Mettre à jour le taux PAS",
        "disabled": _vm.compteRendu.EstTauxPasSalarieActualise
      },
      on: {
        "click": function($event) {
          _vm.mettreAJourTauxPas()
        }
      }
    }, [_c('span', {
      staticClass: "icon fas fa-pencil-alt fa-fw mr-1"
    }), _vm._v(" "), _c('div', {
      staticClass: "text ml-2"
    }, [_vm._v("Mettre à jour le taux PAS")])]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne) ? _c('div', {
    staticClass: "detail-sections"
  }, [_c('div', {
    staticClass: "detail-section section-resume"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 section-header"
  }, [_vm._v("Résumé")]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Nature) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Nature"
    }
  }, [_vm._v("Nature")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Nature
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Nature))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Statut) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Statut"
    }
  }, [_vm._v("Statut")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Statut
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Statut))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identifiant) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Identifiant"
    }
  }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identifiant
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identifiant))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Profil) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Profil"
    }
  }, [_vm._v("Profil")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Profil
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Profil))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Type) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Type
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Type))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Message) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Message
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Message))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Version) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Version"
    }
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Version
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Version))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.ConformiteMetier) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Conformité"
    }
  }, [_vm._v("Conformité")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.ConformiteMetier
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.ConformiteMetier))])]) : _vm._e()])]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.Bilan) ? _c('div', {
    staticClass: "detail-section section-bilan"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 section-header"
  }, [_vm._v("Bilan")]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreSalaries) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Nb salariés"
    }
  }, [_vm._v("Nb salariés")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Bilan.NombreSalaries
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreSalaries))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreDeclarations) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Nb déclarations"
    }
  }, [_vm._v("Nb déclarations")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Bilan.NombreDeclarations
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreDeclarations))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreNonSalaries) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Nb non salariés"
    }
  }, [_vm._v("Nb non salariés")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Bilan.NombreNonSalaries
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreNonSalaries))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.Etat) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "État"
    }
  }, [_vm._v("État")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Bilan.Etat
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.Etat))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ligneCompteRenduSelectionne.Bilan.Compteurs), function(item) {
    return (_vm.ligneCompteRenduSelectionne.Bilan.Compteurs) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": item.Categorie
      }
    }, [_vm._v(_vm._s(item.Categorie))]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Nombre
      }
    }, [_vm._v(_vm._s(item.Nombre))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.Identification) ? _c('div', {
    staticClass: "detail-section section-identification"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 section-header"
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "id-columns"
  }, [_c('div', {
    staticClass: "id-column row"
  }, [(_vm.ligneCompteRenduSelectionne.Identification.DeclarantNom) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Nom déclarant"
    }
  }, [_vm._v("Nom déclarant")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.DeclarantNom
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantNom))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.DeclarantPrenom) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Prénom déclarant"
    }
  }, [_vm._v("Prénom déclarant")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.DeclarantPrenom
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantPrenom))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.DeclarantSiret) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Siret déclarant"
    }
  }, [_vm._v("Siret déclarant")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.DeclarantSiret
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantSiret))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.Conformite) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Conformite"
    }
  }, [_vm._v("Conformite")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.Conformite
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.Conformite))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.SiretEmetteur) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Siret Emetteur"
    }
  }, [_vm._v("Siret Emetteur")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.SiretEmetteur
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.SiretEmetteur))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.Type) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.Type
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.Type))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.PointDeDepot) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Dépôt"
    }
  }, [_vm._v("Dépôt")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.PointDeDepot
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.PointDeDepot))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.TypeEnvoi) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "TypeEnvoi"
    }
  }, [_vm._v("TypeEnvoi")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.TypeEnvoi
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.TypeEnvoi))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "id-column row"
  }, [(_vm.ligneCompteRenduSelectionne.Identification.Identifiant) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Identifiant"
    }
  }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.Identifiant
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.Identifiant))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.IdFlux) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Flux"
    }
  }, [_vm._v("Flux")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.IdFlux
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.IdFlux))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.VersionNorme) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Norme"
    }
  }, [_vm._v("Norme")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.VersionNorme
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.VersionNorme))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.NomLogiciel) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Logiciel"
    }
  }, [_vm._v("Logiciel")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.NomLogiciel
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.NomLogiciel))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.EditeurLogiciel) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Éditeur"
    }
  }, [_vm._v("Éditeur")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.EditeurLogiciel
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.EditeurLogiciel))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.VersionLogiciel) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Version"
    }
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.VersionLogiciel
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identification.VersionLogiciel))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.ListeEffectifs) ? _c('div', {
    staticClass: "detail-section section-effectifs"
  }, [_c('div', {
    staticClass: "card-salarie-header"
  }, [_vm._v("Liste des effectifs du " + _vm._s(_vm._f("moment")(_vm.ligneCompteRenduSelectionne.ListeEffectifs[0].DateDebutPeriode, "DD/MM/YY")) + " au " + _vm._s(_vm._f("moment")(_vm.ligneCompteRenduSelectionne.ListeEffectifs[0].DateFinPeriode, "DD/MM/YY")))]), _vm._v(" "), _vm._l((_vm.ligneCompteRenduSelectionne.ListeEffectifs), function(item) {
    return _c('div', {
      staticClass: "effectif-row"
    }, [_c('div', {
      staticClass: "effectif-label"
    }, [_vm._v(_vm._s(_vm.getCodeEffectif(item.CodeEffectif)) + " " + _vm._s(item.Libelle))]), _vm._v(" "), _c('div', {
      staticClass: "effectif-value"
    }, [_vm._v(_vm._s(item.Valeur))])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && (_vm.ligneCompteRenduSelectionne.CodeRetourGlobalOc || _vm.ligneCompteRenduSelectionne.ListeRetoursMetierOc)) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_vm._m(3), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.CodeRetourGlobalOc) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-label",
    attrs: {
      "title": "Code retour global"
    }
  }, [_vm._v("Code retour global")]), _vm._v(" "), _c('div', {
    staticClass: "field-value",
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.CodeRetourGlobalOc + ' ' + _vm.ligneCompteRenduSelectionne.ComplementRetourGlobalOc
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.CodeRetourGlobalOc) + " " + _vm._s(_vm.ligneCompteRenduSelectionne.ComplementRetourGlobalOc))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tbody section-content"
  }, _vm._l((_vm.ligneCompteRenduSelectionne.ListeRetoursMetierOc), function(item) {
    return _c('div', {
      staticClass: "trow anomalie"
    }, [_c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Code"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Code
      }
    }, [_vm._v(_vm._s(item.Code)), (item.Criticite) ? _c('span', [_vm._v(" (criticité " + _vm._s(item.Criticite) + ")")]) : _vm._e()])]), _vm._v(" "), (item.Libelle) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Libellé"
      }
    }, [_vm._v("Libellé")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Libelle
      }
    }, [_vm._v(_vm._s(item.Libelle))])]) : _vm._e(), _vm._v(" "), (item.Description) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Description"
      }
    }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Description
      }
    }, [_vm._v(_vm._s(item.Description))])]) : _vm._e(), _vm._v(" "), (item.Rubrique) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Rubrique"
      }
    }, [_vm._v("Rubrique")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Rubrique + ' ' + item.LibelleRubrique
      }
    }, [_vm._v(_vm._s(item.Rubrique) + " " + _vm._s(item.LibelleRubrique))])]) : _vm._e(), _vm._v(" "), (item.ValeurRubrique) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Valeur en erreur"
      }
    }, [_vm._v("Valeur en erreur")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.ValeurRubrique
      }
    }, [_vm._v(_vm._s(item.ValeurRubrique))])]) : _vm._e(), _vm._v(" "), (item.ValeurCorrigee) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Valeur corrigée"
      }
    }, [_vm._v("Valeur corrigée")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.ValeurCorrigee
      }
    }, [_vm._v(_vm._s(item.ValeurCorrigee))])]) : _vm._e(), _vm._v(" "), (item.NombreErreursSimilaires) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Nb erreurs similaires"
      }
    }, [_vm._v("Nb erreurs similaires")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.NombreErreursSimilaires
      }
    }, [_vm._v(_vm._s(item.NombreErreursSimilaires))])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.ListeAnomaliesNeores) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "tbody section-content"
  }, _vm._l((_vm.ligneCompteRenduSelectionne.ListeAnomaliesNeores), function(item) {
    return _c('div', {
      staticClass: "trow anomalie"
    }, [(item.CodeTraitement) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Code"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.CodeTraitement
      }
    }, [_vm._v(_vm._s(item.CodeTraitement)), (item.Niveau) ? _c('span', [_vm._v(" (" + _vm._s(item.Niveau) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (item.Libelle) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Libellé"
      }
    }, [_vm._v("Libellé")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Libelle
      }
    }, [_vm._v(_vm._s(item.Libelle))])]) : _vm._e(), _vm._v(" "), (item.ResultatControle) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Résultat du contrôle"
      }
    }, [_vm._v("Résultat du contrôle")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.ResultatControle
      }
    }, [_vm._v(_vm._s(item.ResultatControle))])]) : _vm._e(), _vm._v(" "), (item.NombreIndividus) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Nb individus"
      }
    }, [_vm._v("Nb individus")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.NombreIndividus
      }
    }, [_vm._v(_vm._s(item.NombreIndividus))])]) : _vm._e(), _vm._v(" "), (item.NombreContrats) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Nb contrats"
      }
    }, [_vm._v("Nb contrats")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.NombreContrats
      }
    }, [_vm._v(_vm._s(item.NombreContrats))])]) : _vm._e(), _vm._v(" "), (item.Controle) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Contrôle"
      }
    }, [_vm._v("Contrôle")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Controle
      }
    }, [_vm._v(_vm._s(item.Controle))])]) : _vm._e(), _vm._v(" "), (item.ActionAttendue) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Action attendue"
      }
    }, [_vm._v("Action attendue")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.ActionAttendue
      }
    }, [_vm._v(_vm._s(item.ActionAttendue))])]) : _vm._e(), _vm._v(" "), (item.AideUtilisateur) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Aide"
      }
    }, [_vm._v("Aide")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.AideUtilisateur
      }
    }, [_vm._v(_vm._s(item.AideUtilisateur))])]) : _vm._e(), _vm._v(" "), (item.Consequences) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Conséquences"
      }
    }, [_vm._v("Conséquences")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Consequences
      }
    }, [_vm._v(_vm._s(item.Consequences))])]) : _vm._e(), _vm._v(" "), (item.ReferenceReglementaire) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Référence réglementaire"
      }
    }, [_vm._v("Référence réglementaire")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.ReferenceReglementaire
      }
    }, [_vm._v(_vm._s(item.ReferenceReglementaire))])]) : _vm._e(), _vm._v(" "), (item.CaractereSubstituable) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Caractère substituable"
      }
    }, [_vm._v("Caractère substituable")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.CaractereSubstituable
      }
    }, [_vm._v(_vm._s(item.CaractereSubstituable))])]) : _vm._e(), _vm._v(" "), (item.RappelAvantCorrection) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Rappel avant correction"
      }
    }, [_vm._v("Rappel avant correction")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.RappelAvantCorrection
      }
    }, [_vm._v(_vm._s(item.RappelAvantCorrection))])]) : _vm._e(), _vm._v(" "), (item.CasException) ? _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Cas d'exception"
      }
    }, [_vm._v("Cas d'exception")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.CasException
      }
    }, [_vm._v(_vm._s(item.CasException))])]) : _vm._e(), _vm._v(" "), _vm._l((item.ListeAtypies), function(atypie) {
      return _c('div', {
        staticClass: "atypie"
      }, [(atypie.Detail) ? _c('div', {
        staticClass: "field-row"
      }, [_c('div', {
        staticClass: "field-label",
        attrs: {
          "title": "Détail"
        }
      }, [_vm._v("Détail")]), _vm._v(" "), _c('div', {
        staticClass: "field-value",
        attrs: {
          "title": atypie.Detail
        }
      }, [_vm._v(_vm._s(atypie.Detail))])]) : _vm._e(), _vm._v(" "), (atypie.DateDebutPeriode || atypie.DateFinPeriode) ? _c('div', {
        staticClass: "field-row"
      }, [_c('div', {
        staticClass: "field-label",
        attrs: {
          "title": "Période"
        }
      }, [_vm._v("Période")]), _vm._v(" "), _c('div', {
        staticClass: "field-value",
        attrs: {
          "title": atypie.DateDebutPeriode + ' - ' + atypie.DateFinPeriode
        }
      }, [_vm._v(_vm._s(atypie.DateDebutPeriode) + " - " + _vm._s(atypie.DateFinPeriode))])]) : _vm._e(), _vm._v(" "), (atypie.MontantRecalcule) ? _c('div', {
        staticClass: "field-row"
      }, [_c('div', {
        staticClass: "field-label",
        attrs: {
          "title": "Montant recalculé"
        }
      }, [_vm._v("Montant recalculé")]), _vm._v(" "), _c('div', {
        staticClass: "field-value",
        attrs: {
          "title": atypie.MontantRecalcule
        }
      }, [_vm._v(_vm._s(atypie.MontantRecalcule))])]) : _vm._e(), _vm._v(" "), _vm._l((atypie.ListeIndividus), function(individu) {
        return _c('div', {
          staticClass: "field-row"
        }, [_c('div', {
          staticClass: "field-label",
          attrs: {
            "title": "Individu"
          }
        }, [_vm._v("Individu")]), _vm._v(" "), _c('div', {
          staticClass: "field-value",
          attrs: {
            "title": individu.Nom + ' ' + individu.Prenom
          }
        }, [_vm._v(_vm._s(individu.Nom) + " " + _vm._s(individu.Prenom) + " "), (individu.Nir) ? _c('span', [_vm._v("(NIR " + _vm._s(individu.Nir) + ")")]) : (individu.NumeroTechniqueTemporaire) ? _c('span', [_vm._v("(NTT " + _vm._s(individu.NumeroTechniqueTemporaire) + ")")]) : _vm._e(), (individu.Matricule) ? _c('span', [_vm._v(" - matricule " + _vm._s(individu.Matricule))]) : _vm._e(), (individu.NumeroContrat) ? _c('span', [_vm._v(" - contrat " + _vm._s(individu.NumeroContrat))]) : _vm._e()])])
      }), _vm._v(" "), _vm._l((atypie.ListeRubriques), function(rubrique) {
        return _c('div', {
          staticClass: "field-row"
        }, [_c('div', {
          staticClass: "field-label",
          attrs: {
            "title": 'Rubrique ' + rubrique.CodeRubrique
          }
        }, [_vm._v("Rubrique " + _vm._s(rubrique.CodeRubrique))]), _vm._v(" "), _c('div', {
          staticClass: "field-value",
          attrs: {
            "title": rubrique.ValeurDeclaree
          }
        }, [_vm._v(_vm._s(rubrique.ValeurDeclaree)), (rubrique.ValeurPreconisee) ? _c('span', [_vm._v(" → " + _vm._s(rubrique.ValeurPreconisee))]) : _vm._e(), (rubrique.ResultatControle) ? _c('span', [_vm._v(" (" + _vm._s(rubrique.ResultatControle) + ")")]) : _vm._e()])])
      })], 2)
    })], 2)
  }))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.DetailNonExploitable) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_vm._v("Le contenu de ce retour n'a pas pu être interprété. Flux brut :")]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.FluxBrut) ? _c('pre', {
    staticClass: "flux-brut"
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.FluxBrut))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.anomaliesList) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tbody section-content"
  }, _vm._l((_vm.anomaliesList), function(item) {
    return _c('div', {
      staticClass: "trow anomalie"
    }, [(item.Description) ? _c('div', [_c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Code"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Description.Code
      }
    }, [_vm._v(_vm._s(item.Description.Code))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Categorie"
      }
    }, [_vm._v("Categorie")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Description.Categorie
      }
    }, [_vm._v(_vm._s(item.Description.Categorie))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Message"
      }
    }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Description.Message
      }
    }, [_vm._v(_vm._s(item.Description.Message))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Numero Ligne"
      }
    }, [_vm._v("Numero Ligne")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Description.NumeroLigne
      }
    }, [_vm._v(_vm._s(item.Description.NumeroLigne))])])]) : _vm._e(), _vm._v(" "), (item.Valeur) ? _c('div', [_c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Identifiant"
      }
    }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Valeur.Identifiant
      }
    }, [_vm._v(_vm._s(item.Valeur.Identifiant))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Libelle"
      }
    }, [_vm._v("Libelle")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Valeur.Libelle
      }
    }, [_vm._v(_vm._s(item.Valeur.Libelle))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row"
    }, [_c('div', {
      staticClass: "field-label",
      attrs: {
        "title": "Valeur"
      }
    }, [_vm._v("Valeur")]), _vm._v(" "), _c('div', {
      staticClass: "field-value",
      attrs: {
        "title": item.Valeur.Valeur
      }
    }, [_vm._v(_vm._s(item.Valeur.Valeur))])])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isLoading !== 0) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal cancel ml-1 mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Fermer")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Compte rendu de la DSN")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "tr"
  }, [_c('th', {
    staticClass: "th cln-nature",
    attrs: {
      "title": "Nature"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nature")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-libelle",
    attrs: {
      "title": "Libellé"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Libellé")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-statut",
    attrs: {
      "title": "Statut"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Statut")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "line"
  }, [_c('th', {
    staticClass: "section cln-nature"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-libelle"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-statut"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("Retours métier de l'organisme complémentaire")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("Contrôles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("Détail non exploitable")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("Anomalies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b42d34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsn/modalCompteRenduDsn/modalCompteRenduDsn.vue.html
// module id = uwY5
// module chunks = 2